import React, { Component } from 'react'
import { List, Avatar, Divider } from 'antd'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    transactionHistory: state.bankSimulator.transactionHistory,
  }
}
const transactionHistoryFrameStyle = {
  height: '250px',
  marginTop: '10px',
  marginLeft: '6px',
  marginRight: '6px',
  overflowY: 'scroll',
}
@connect(mapStateToProps)
class TransferHistory extends Component {
  renderTitle = item => {
    return (
      <div>
        {item.name} of ₦ {item.amount}
        <br />
        {item.reference}
        {item.amount}
        <Divider />
      </div>
    )
  }

  render() {
    return (
      <div className="row" style={transactionHistoryFrameStyle}>
        <div style={{ height: '500px' }}>
          <List
            itemLayout="horizontal"
            dataSource={this.props.transactionHistory}
            renderItem={item => (
              <List.Item>
                <List.Item.Meta title={this.renderTitle(item)} description={item.item} />
              </List.Item>
            )}
          />
        </div>
      </div>
    )
  }
}
export default TransferHistory



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/InternetBankingSimulatorApp/screens/BalanceScreen/TransferHistory/index.js